import React, { useState, useEffect } from 'react'
import Comments from '@components/app/comments'
import Curve from '@components/app/curve'
import AboutEditor from '@components/app/editor/about'
import LyricsEditor from '@components/app/editor/lyrics'
// import Clap from '@components/app/clap'
// import BtnPlay from '@components/app/button-play'
import Share from '@components/app/share'
import Showmore from '@components/app/show-more'
import Waveform from '@components/app/waveform'
import Button from '@components/common/button'
import BuyModal from '@components/modals/buy'
import UIHiresBadge from '@components/ui/hires'
import UISample from '@components/ui/sample'
import { getMediaDownload } from '@data/api/download'
import { addFeature } from '@data/api/feature'
import Image from 'next/image'
import Link from 'next/link'
import Router from 'next/router'
import { FormattedMessage, FormattedDate, FormattedNumber } from 'react-intl'
import useMediaQuery from '@/hooks/media-query'
import CdnImage from '@/components/app/cdn-image'
import { SoundProps } from '../../../../types/sound'
import Coverart from '../coverart'
import styles from '../media.module.scss'
import Userinfo from '../userinfo'
import BtnPlay from './play'

interface Props {
  openBuy: boolean
  defaultSound: SoundProps
  isMine?: boolean
  toggleEdit: () => void
  isAdmin: boolean
}
const Sound = ({
  openBuy,
  defaultSound,
  isMine = false,
  toggleEdit,
  isAdmin,
}: Props) => {
  const [ isBuyOpen, setBuyOpen ] = useState(openBuy)
  const [ downloadId, setDownload ] = useState()
  const [ sound, setSound ] = useState(defaultSound)

  const { isMobile } = useMediaQuery()
  // const { showDescMore, showLyricsMore } = this.state

  const onSale = sound.sales && sound.sales.on

  const onFeature = async () => {
    const result = await addFeature('Sound', sound.id)
    // eslint-disable-next-line no-console
    console.log(result)
  }

  const checkDownload = async () => {
    const result = await getMediaDownload(sound.id)

    if (!result.purchased || result.error) {
      return
    }
    sound.limit.on = false
    setSound(sound)
    setDownload(result.downloadId)
  }

  useEffect(() => {
    checkDownload()
  }, [])

  return (
    <div className={styles.mediaContainer}>
      <style jsx>
        {`
          .cover {
            background-image: url(${sound.coverart_blur_url});
          }
        `}
      </style>
      <div className={`${styles.mediaCover} cover`} />
      <Curve className={styles.coverartBlurContainer}>
        <Image
          src={sound.coverart_blur_url}
          alt=""
          className={styles.coverartBlurImage}
          priority
          fill
        />
      </Curve>
      <div className="container-md">
        <div className={`d-flex ${styles.header}`}>
          <div className={`${styles.coverartContainer}`}>
            <div className="ps-relative d-inline-block m-auto">
              <Coverart src={sound.coverart_crop_url} alt={sound.title} />
            </div>
            {isAdmin && (
              <div className="mt-5">
                <Button className="lg" onClick={onFeature}>
                  feature
                </Button>
              </div>
            )}
            {isMine && (
              <div className="mt-3">
                <Button className="lg" onClick={toggleEdit}>
                  <FormattedMessage
                    id="sound.edit.btnLabel"
                    defaultMessage="Edit this Sound"
                  />
                </Button>
              </div>
            )}
          </div>
          <div className={`${styles.heading} mb-5`}>
            <div className={styles.headingText}>
              <div className="d-flex align-items-center mb-4">
                <div className="flex0 mr-3">
                  <BtnPlay sound={sound} />
                </div>
                <div className="flex1">
                  <h1 className={`${styles.title} tx-24 tx-w700 mb-1`}>
                    {sound.title}
                  </h1>
                  {sound.subtitle && (
                    <h2 className={`${styles.subtitle} tx-16 tx-w300`}>
                      {sound.subtitle}
                    </h2>
                  )}
                  {sound.released_at && (
                    <span className={`${styles.released} tx-w300 tx-14`}>
                      <span>Released</span>
                      <span className="dot" />
                      <time>
                        <FormattedDate value={sound.released_at} />
                      </time>
                    </span>
                  )}
                  {(sound.hi_resolution || (sound.limit && sound.limit.on)) && (
                    <div className="d-flex align-items-center mt-2">
                      {sound.hi_resolution && <UIHiresBadge className="mr-2" />}
                      {sound.limit && sound.limit.on && <UISample />}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Waveform
              id={sound.id}
              duration={sound.metadata.duration}
              src={sound.waveform_url}
              className={styles.waveform}
              outerColor={
                isMobile ? 'rgba(0, 0, 0, .3)' : 'rgba(255, 255, 255, .6)'
              }
              static={sound.limit.on}
            />
            <div className="d-md-flex align-items-center">
              <div className="flex1 my-md-0 my-5">
                {/* <Clap
                  soundId={sound.id}
                  clap={sound.userClaps}
                  total={sound.claps}
                  users={sound.clapUsers}
                /> */}
              </div>
              <div className="flex0">
                <Share
                  type="sound"
                  id={sound.id}
                  url={`https://sdn.lv/s${sound.id}`}
                  text={`${sound.title} by ${sound.user.name}`}
                />
              </div>
            </div>
            <div className="hr" />
            {sound.description && (
              <Showmore
                defaultHeight={116}
                className={`${styles.description} tx-g800 tx-14 tx-l16`}
              >
                <AboutEditor about={sound.description} readOnly />
              </Showmore>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 order-md-2 mb-5">
            {onSale && (
              <>
                <h2 className="heading-sm tx-oswald tx-w400 tx-20">
                  <span className="text">
                    <span className="solicon-tag-cord mr-1 align-baseline" />
                    On Sale
                  </span>
                </h2>
                {!downloadId ? (
                  <p className="tx-center mb-2">
                    <FormattedMessage
                      id="app.buy.soundMessage"
                      defaultMessage="Buy this sound to support {name}."
                      values={{
                        name: sound.user.name,
                        br: <br />,
                        // eslint-disable-next-line react/display-name
                        strong: (...chunks) => <strong>{chunks}</strong>,
                      }}
                    />
                  </p>
                ) : (
                  <p className="tx-center mb-4">
                    <FormattedMessage
                      id="app.buy.purchased.soundMessage"
                      defaultMessage="You've already purchased this sound."
                    />
                  </p>
                )}
                {!downloadId && (
                  <div className="tx-center mb-4">
                    <i className="solicon-yen mr-1 align-baseline" />
                    <span className="tx-oswald tx-w600 tx-32">
                      <FormattedNumber
                        value={sound.sales.price ?? sound.price ?? 0}
                      />
                    </span>
                    {sound.sales.nameyourprice && (
                      <span className="ml-1">
                        <FormattedMessage
                          id="buy.more"
                          defaultMessage="or more"
                        />
                      </span>
                    )}
                  </div>
                )}
                <div className="tx-center mb-5">
                  {!downloadId ? (
                    <Button
                      className="lg primary-alt shadow"
                      onClick={() => setBuyOpen(true)}
                      disabled={isMine}
                    >
                      <FormattedMessage
                        id="app.buy.sound"
                        defaultMessage="Buy This Sound"
                      />
                    </Button>
                  ) : (
                    <Button
                      className="lg primary-alt shadow"
                      onClick={() =>
                        Router.push(
                          `/download?id=${downloadId}`,
                          `/download/${downloadId}`,
                        )
                      }
                    >
                      <FormattedMessage
                        id="download.button"
                        defaultMessage="Download"
                      />
                    </Button>
                  )}
                </div>
                <div className="hr" />
              </>
            )}
            {sound.album && (
              <div className="d-flex mb-3">
                <div className="flex0 mr-3">
                  <Link
                    href={`/album/${sound.album.id}/${sound.album.slug}`}
                    className={`d-block ${styles.userAvatar}`}
                    aria-label={`View more about ${sound.album.title}`}
                  >
                    <figure>
                      <CdnImage
                        src={sound.album.coverart_crop_url}
                        // className="maxW100p"
                        width={80}
                        height={80}
                        alt={sound.album.title}
                      />
                    </figure>
                  </Link>
                </div>
                <div className="flex1 border-b300">
                  <div className="tx-g600 tx-12">on a album</div>
                  <Link
                    href={`/album/${sound.album.id}/${sound.album.slug}`}
                    className="d-block alt tx-16 tx-w600 tx-g900 mb-2"
                  >
                    {sound.album.title}
                  </Link>
                  {sound.album.description && (
                    <p className="tx-12 tx-g800">
                      <Link
                        href={`/album/${sound.album.id}/${sound.album.slug}`}
                        className="nohover tx-g800"
                      >
                        {sound.album.description.substr(0, 50)}
                        {sound.album.description.length > 50 && '...'}
                      </Link>
                    </p>
                  )}
                </div>
              </div>
            )}
            <Userinfo
              name={sound.user.name}
              username={sound.user.username}
              imageUrl={sound.user.user_image}
              shortBio={sound.user.shortBio}
            />
          </div>{' '}
          {/* end right column */}
          <div className="col-md-8">
            {sound.lyrics && (
              <div className="mb-5">
                <h2 className="heading">
                  <span className="text">Lyrics</span>
                </h2>
                <Showmore
                  defaultHeight={116}
                  className={`${styles.lyrics} tx-g800 tx-14 tx-l16`}
                >
                  <LyricsEditor lyrics={sound.lyrics} readOnly />
                </Showmore>
              </div>
            )}
            <div className="mb-5">
              <h2 className="heading">
                <span className="text">Comments</span>
              </h2>
              <Comments type="sound" id={sound.id} owner={sound.user.id} />
            </div>
          </div>{' '}
          {/* end left column */}
        </div>
      </div>
      <BuyModal
        category="sound"
        data={sound}
        isOpen={isBuyOpen}
        onClose={() => setBuyOpen(false)}
      />
    </div>
  )
}

export default Sound
